import { render, staticRenderFns } from "./DeleteMediaPopup.vue?vue&type=template&id=18939d97&scoped=true&"
import script from "./DeleteMediaPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteMediaPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteMediaPopup.vue?vue&type=style&index=0&id=18939d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18939d97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18939d97')) {
      api.createRecord('18939d97', component.options)
    } else {
      api.reload('18939d97', component.options)
    }
    module.hot.accept("./DeleteMediaPopup.vue?vue&type=template&id=18939d97&scoped=true&", function () {
      api.rerender('18939d97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DeleteMediaPopup.vue"
export default component.exports